import { render, staticRenderFns } from "./HandsUpPreview.vue?vue&type=template&id=754e41ab&lang=pug&"
import script from "./HandsUpPreview.vue?vue&type=script&lang=js&"
export * from "./HandsUpPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports